import { handleResponse, handleError } from '../apiUtils';
import axiosInstance from '../axiosConfig';
import { getAdminBaseUrl } from './administrationUtils';

export function getFormTemplates(accountId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance.request({
    method: 'get',
    url: `${url}/form_templates`,
  });
}

export function saveFormTemplate(data, accountId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'post',
      url: `${url}/form_templates`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}

export function updateFormTemplate(data, accountId, formId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'put',
      url: `${url}/form_templates/${formId}`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}

export function duplicateFormTemplate(data, accountId, formId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'post',
      url: `${url}/form_templates/${formId}/duplicate`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}

export function updateFormTemplateTrialContainers(data, accountId, formId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'post',
      url: `${url}/form_templates/${formId}/trial_containers`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}

export function toggleFormTemplateActive(data, accountId, formId) {
  const url = getAdminBaseUrl(accountId);

  return axiosInstance
    .request({
      method: 'put',
      url: `${url}/form_templates/${formId}/active`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}

export function updateFormTemplateWorkflow(data, accountId, formTemplateId) {
  return axiosInstance
    .request({
      method: 'put',
      url: `${getAdminBaseUrl(accountId)}/form_templates/${formTemplateId}/workflow_definitions`,
      data: data,
    })
    .then(handleResponse)
    .catch(handleError);
}
